export const terminations = (state) => state.eContracts.terminations
export const eContractParams = (state) => state.eContracts

export const terminationXML = (state) => state.eContracts.termination.xml
export const terminationIsLoading = (state) => state.eContracts.termination.isLoading
export const terminationIsSuccess = (state) => state.eContracts.termination.isSuccess
